import { Box, Dialog, DialogContent, DialogTitle, Tab, Tabs } from '@material-ui/core'
import React, { useState } from 'react'
import PropTypes from "prop-types";
import { SURGE_BANDEJA_IMAGENES_MENU } from '../../../../../utils/constants'
import { useSelector } from 'react-redux';
import { AfiliadoMenu } from '../../../../autorizaciones/gestionAuditoria/Menus/AfiliadoMenu';
import { InformacionMenu } from '../../../../autorizaciones/gestionAuditoria/Menus/InformacionMenu';
import { NotasMenu } from '../../../../autorizaciones/gestionAuditoria/Menus/NotasMenu';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      name={index}
      {...other}
    >
      {value === index && <Box p={2}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}


export const Modalnformacion = (props) => {

  const { solicitudSeleccionada = {} } = useSelector((state) => state.autorizaciones);

  const [selectedTab, setSelectedTab] = useState(
    SURGE_BANDEJA_IMAGENES_MENU.AFILIADO
  );

  return (
    <Dialog
      fullWidth
      //maxWidth="md"
      maxWidth="lg"
      onClose={props.closeModalHandler}
      open={props.open}
    >
      <DialogTitle>{`IDSolicitud: ${solicitudSeleccionada?.idSolicitud}`}</DialogTitle>

      <DialogContent>
        <Tabs
          value={selectedTab}
          onChange={(event, newValue) => setSelectedTab(newValue)}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
        >
          <Tab
            value={SURGE_BANDEJA_IMAGENES_MENU.AFILIADO}
            label="Afiliado"
            {...a11yProps(SURGE_BANDEJA_IMAGENES_MENU.AFILIADO)}
          />
          <Tab
            value={SURGE_BANDEJA_IMAGENES_MENU.INFORMACION}
            label="Información"
            {...a11yProps(SURGE_BANDEJA_IMAGENES_MENU.INFORMACION)}
          />
          <Tab
            value={SURGE_BANDEJA_IMAGENES_MENU.NOTAS}
            label="Notas"
            {...a11yProps(SURGE_BANDEJA_IMAGENES_MENU.NOTAS)}
          />
        </Tabs>
        <TabPanel
          value={selectedTab}
          index={SURGE_BANDEJA_IMAGENES_MENU.AFILIADO}
        >
          <AfiliadoMenu
            solicitud={true}
            afiliado={solicitudSeleccionada?.afiliado}
            idMotivoInternacion={solicitudSeleccionada?.idMotivoInternacion}
            filtros={props.filtros}
            desdeBandejaRecupero={true}
          />
        </TabPanel>
        <TabPanel
          value={selectedTab}
          index={SURGE_BANDEJA_IMAGENES_MENU.INFORMACION}
        >
          <InformacionMenu
            onCloseModalAuditar={props.closeModalHandler}
            disabled={true}
            filtros={props.filtros}
            seguimiento={props.seguimiento}
            desdeBandejaSurge={true}
          />
        </TabPanel>
        <TabPanel
          value={selectedTab}
          index={SURGE_BANDEJA_IMAGENES_MENU.NOTAS}
        >
          <NotasMenu
            disabled={true}
            filtros={props.filtros} />
        </TabPanel>
      </DialogContent>
    </Dialog >
  )
}
